import React from 'react'
import { LoadingOutlined } from '@ant-design/icons'

export const antIcon = <LoadingOutlined style={{ fontSize: '24px' }} spin />
export const value = 'Fetching data'
